module.exports = __webpack_public_path__ + "static/media/food-chains-in-peril-mobile.ca498eee.jpg";